import { render } from "./LocalizationDataCard.vue?vue&type=template&id=4c0ed5f7&scoped=true"
import script from "./LocalizationDataCard.vue?vue&type=script&lang=js"
export * from "./LocalizationDataCard.vue?vue&type=script&lang=js"

import "./LocalizationDataCard.vue?vue&type=style&index=0&id=4c0ed5f7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0ed5f7"]])

export default __exports__